export default __webpack_public_path__ + "static/media/NFL.57ad9beb.svg";